import { getSkipCount } from './getSkipCount';
import { persistGridFilters } from './savedFilters';

export function paginate(arr, size) {
    return arr.reduce((acc, val, i) => {
        let idx = Math.floor(i / size);
        let page = acc[idx] || (acc[idx] = []);
        page.push(val);
        return acc;
    }, []);
}

// `location.state` is where every grid keeps its filters and what its fetch effect keys
// on, so these two functions are the only place a filter can change. That makes them the
// one place to mirror it to the user's saved preferences — see ./savedFilters. Paths that
// own no grid (most of them) persist nothing, and pagination-only calls are deduped away.

export const SavePage = (navigate, info, anotherInfo) => {
    const location = window.location.pathname;
    const state = {
        limit: 50,
        skip: info?.skip ? info?.skip : 0,
        page: info?.page ? info?.page : 1,
        ...anotherInfo,
    };

    navigate(location, { state });
    persistGridFilters(location, state);
};

export const SaveParams = (navigate, anotherInfo) => {
    const location = window.location.pathname;
    const state = {
        ...anotherInfo,
    };

    navigate(location, { state });
    persistGridFilters(location, state);
};

export const SendPageSave = (number, info, navigate) => {
    const _skip = getSkipCount(number, 50);
    const pushInfo = { ...info };
    pushInfo.page = number;
    pushInfo.skip = _skip;
    SavePage(navigate, info, { ...pushInfo });
};
